import { Field } from '@sitecore-content-sdk/nextjs';

const BreadcrumbQuery = /** GQL */ `query($itemID: String!, $language: String!){
    currentPage: item(path: $itemID, language: $language) {
      ...breadcrumbInfo

      ancestors(hasLayout: true) {
        ...breadcrumbInfo
      }
    }
  }
  
  fragment NavLinks on MultilistField {
    targetItems {
      key: field(name: "key") {
        jsonValue
      }
    }
  }
  fragment breadcrumbInfo on Item {
    Title: field(name: "Title") {
      jsonValue
    }
    url {
      path
    }
            navigationFilter: field(name: "navigationFilter") {
        ...NavLinks
      }
  }`;

export default BreadcrumbQuery;

export type BreadcrumbQueryResult = {
  currentPage: BreadcrumbInfo & {
    ancestors: BreadcrumbInfo[];
  };
};

export type BreadcrumbInfo = {
  navigationFilter: NavLinks;
  url: {
    path: string;
  };
  Title: {
    jsonValue: Field<string>;
  };
};

export type NavLinks = {
  targetItems: NavFilter[];
  url: {
    path: string;
  };
};

export type NavFilter = {
  key: {
    jsonValue: Field<string>;
  };
};
